const baseStyle = () => {
  return {
    width: 'auto',
    height: 'auto',
  };
};

export default {
  baseStyle,
  defaultProps: {
    isUnderlined: true,
  },
};
